(function() { module.exports = window["ClipboardJS"]; }());